import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ITrailerType, TrailerType} from 'app/blocks/model/trailer-type.model';
import {Resource} from 'app/constants/resource';

import EntityCrudService from 'app/blocks/service/api/entity-service';

@Injectable({
    providedIn: 'root'
})
export class TrailerTypeService extends EntityCrudService<ITrailerType> {
    constructor(http: HttpClient) {
        super(http, Resource.TRAILER_TYPES, (obj?) => new TrailerType(obj));
    }
}
